import SideBarWrapper from "../../../components/common/SideBarWrapper";
import InvitationCreate from "../../../components/Registration/Invitations/InvitationCreate";
import Footer from "../../../layout/Footer";
import Navbar from "../../../layout/Navbar";
import WorkFlowForm from "../../WorkFlow/WorkFlowForm";


const InvitationCreateIndex = () => {
    return (
    <>
        {/* Loading starts */}
        {/* <div id="loading-wrapper">
            <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div> */}
        {/* Loading ends */}


        {/* Page wrapper start */}
        <div className="page-wrapper">

            {/* Sidebar wrapper start */}
            <SideBarWrapper />
            {/* Sidebar wrapper end */}

            {/* Page content start  */}
            <div className="page-content">

                {/* Header start */}
                <Navbar />
                {/* Header end */}

                {/* Page header start */}
                <div className="page-header">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">Registration</li>
                        <li className="breadcrumb-item">Invitation</li>
                        <li className="breadcrumb-item active">Create</li>
                    </ol>
                    <ul className="app-actions">
                    </ul>
                </div>
                {/* Page header end */}

                {/* Main container start */}
                <div className="main-container">
                    <InvitationCreate />
                </div>
                {/* Main container end */}

            </div>
            {/* Page content end */}
            <Footer/>

        </div>
        {/* Page wrapper end */}
    </> );
}
 
export default InvitationCreateIndex;